import type { GoogleBusinessInfoResponse, GoogleBusinessLocation } from "./types"

export const GOOGLE_BUSINESS_AUTH_REQUESTED = "locations/googleBusiness/authRequested"
export const googleBusinessAuthRequested = (locationId: string, accountId: string) => ({
    type: GOOGLE_BUSINESS_AUTH_REQUESTED,
    payload: {
        locationId: locationId,
        accountId: accountId,
    },
})

export const GOOGLE_BUSINESS_INFO_FETCH_REQUESTED = "locations/googleBusiness/infoFetchRequested"
export const googleBusinessInfoFetchRequested = (locationId: string) => ({
    type: GOOGLE_BUSINESS_INFO_FETCH_REQUESTED,
    payload: {
        locationId: locationId,
    },
})

export const GOOGLE_BUSINESS_INFO_FETCH_SUCCEEDED = "locations/googleBusiness/infoFetchSucceeded"
export const googleBusinessInfoFetchSucceeded = (data: GoogleBusinessInfoResponse) => ({
    type: GOOGLE_BUSINESS_INFO_FETCH_SUCCEEDED,
    payload: data,
})

export const GOOGLE_BUSINESS_INFO_FETCH_FAILED = "locations/googleBusiness/infoFetchFailed"
export const googleBusinessInfoFetchFailed = (error: string) => ({
    type: GOOGLE_BUSINESS_INFO_FETCH_FAILED,
    payload: {
        error: error,
    },
})

export const GOOGLE_BUSINESS_LOCATION_SELECTED = "locations/googleBusiness/locationSelected"
export const googleBusinessLocationSelected = (
    figureLocationId: string,
    figureAccountId: string,
    googleAccountResourceName: string,
    googleLocation: GoogleBusinessLocation
) => ({
    type: GOOGLE_BUSINESS_LOCATION_SELECTED,
    payload: {
        figureLocationId: figureLocationId,
        figureAccountId: figureAccountId,
        googleAccountResourceName: googleAccountResourceName,
        googleLocation: googleLocation,
    },
})

export const GOOGLE_BUSINESS_LOCATION_PICKER_CLOSED = "locations/googleBusiness/locationPickerClosed"
export const googleBusinessLocationPickerClosed = () => ({
    type: GOOGLE_BUSINESS_LOCATION_PICKER_CLOSED,
})

export const GOOGLE_BUSINESS_INTEGRATION_SUCCEEDED = "locations/googleBusiness/integrationSucceeded"
export const googleBusinessIntegrationSucceeded = (figureLocationId: string, googleLocationResourceName: string) => ({
    type: GOOGLE_BUSINESS_INTEGRATION_SUCCEEDED,
    payload: {
        figureLocationId: figureLocationId,
        googleLocationResourceName: googleLocationResourceName,
    },
})

export const GOOGLE_BUSINESS_INTEGRATION_FAILED = "locations/googleBusiness/integrationFailed"
export const googleBusinessIntegrationFailed = (error: string) => ({
    type: GOOGLE_BUSINESS_INTEGRATION_FAILED,
    payload: {
        error: error,
    },
})

export const GOOGLE_BUSINESS_INTEGRATION_REMOVE_REQUESTED = "locations/googleBusiness/integrationRemoveRequested"
export const googleBusinessIntegrationRemoveRequested = (figureLocationId: string) => ({
    type: GOOGLE_BUSINESS_INTEGRATION_REMOVE_REQUESTED,
    payload: {
        figureLocationId: figureLocationId,
    },
})

export const GOOGLE_BUSINESS_INTEGRATION_REMOVE_SUCCEEDED = "locations/googleBusiness/integrationRemoveSucceeded"
export const googleBusinessIntegrationRemoveSucceeded = (figureLocationId: string) => ({
    type: GOOGLE_BUSINESS_INTEGRATION_REMOVE_SUCCEEDED,
    payload: {
        figureLocationId: figureLocationId,
    },
})

export const GOOGLE_BUSINESS_INTEGRATION_REMOVE_FAILED = "locations/googleBusiness/integrationRemoveFailed"
export const googleBusinessIntegrationRemoveFailed = (error: string) => ({
    type: GOOGLE_BUSINESS_INTEGRATION_REMOVE_FAILED,
    payload: {
        error: error,
    },
})
